import { useSnackbarHandler } from "@repo/lib/hooks/common";
import { validation } from "@repo/lib/utils";
import { sendOTP } from "@repo/server-actions/account";
import { useTranslations } from "next-intl";
import { useCallback, useTransition } from "react";

const useSendOtp = (formValues, setFormErrors, setShowVerifyOTP) => {
  const [isPending, startTransition] = useTransition();
  const t = useTranslations("Common");
  const { showSnackbar } = useSnackbarHandler();

  const submitForm = useCallback(
    async (resend) => {
      const payLoad = {
        email: formValues?.email,
      };
      const response = await sendOTP(payLoad);
      showSnackbar(response);
      if (response?.success && !resend) setShowVerifyOTP(true);
    },
    [formValues, setShowVerifyOTP, showSnackbar]
  );

  const handleSendOtp = useCallback(
    (e, resend) => {
      e.preventDefault();
      const errors = validation(formValues, t);
      if (Object.keys(errors).length === 0) {
        startTransition(() => submitForm(resend));
      } else {
        setFormErrors(errors);
      }
    },
    [formValues, setFormErrors, submitForm, t]
  );

  return { isPending, handleSendOtp };
};

export default useSendOtp;
